// extracted by mini-css-extract-plugin
export default {"container":"Skeleton_container__mmXqQ","rounded":"Skeleton_rounded__SnR90","circle":"Skeleton_circle__FJcT+","load-skeleton":"Skeleton_load-skeleton__LGN7L"};